import { ButtonProps, Button } from '../../../button/Button';

export function EntityWizardSelectEntity({ entity }: { entity?: string }) {
  return <span className='text-italic text-medium'>Select {entity} to continue</span>;
}

export function EntityWizardEntitySubmit(props?: Partial<ButtonProps>) {
  if (!props?.children) {
    return null;
  }

  return (
    <Button
      dataId='wizard-entity-submit'
      type='submit'
      icon='add-arrow-right'
      direction='right'
      size='sm'
      {...props}
    />
  );
}
